<template>
  <modal @leave="$emit('leave')" show-close-btn width="600px" class="leading-normal">
    <h2 class="font-normal mb-4">Blacklist a Property</h2>
    <p class="mb-4">Please enter the address of the property you want to blacklist.</p>
    <div class="flex flex-wrap -mx-2 mb-3">
      <div class="w-full md:w-1/4 px-2">
        <label for="lookup_postcode">Post Code:</label>
        <input type="text" v-model="address[postcodeKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3 uppercase" maxlength="8" />
      </div>

      <div class="w-full md:w-3/4 px-2">
        <label for="lookup_postcode">Address:</label>
        <loader v-if="searching" />
        <select v-else v-model="selectedSuggestion" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3">
          <option :value="null">[Please Select]</option>
          <option v-for="(suggestion, i) in suggestions" :key="i" :value="suggestion.data">
            {{ suggestion.formatted }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="!manualOpen && !address[nameNumberKey]" class="text-right underline hover:text-blue-dark text-sm cursor-pointer" @click="manualOpen = true">
      Can't find the address?
    </div>
    <div v-else>
      <div v-if="nameKey" class="mb-6">
        <label>Recipient Name:</label>
        <input type="text" v-model="address[nameKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="flex flex-wrap -mx-2">
        <div class="w-full md:w-1/2 px-2 mb-6">
          <label>Line 1:</label>
          <input type="text" v-model="address[nameNumberKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
        </div>
        <div class="w-full md:w-1/2 px-2 mb-6">
          <label>Line 2:</label>
          <input type="text" v-model="address[streetKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
        </div>
      </div>
      <div class="mb-6">
        <label>Line 3:</label>
        <input type="text" v-model="address[line3Key]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="mb-6">
        <label>Town:</label>
        <input type="text" v-model="address[townKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="mb-6">
        <label>County:</label>
        <input type="text" v-model="address[countyKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="mb-6">
        <label>Post Code:</label>
        <input type="text" v-model="address[postcodeKey]" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
    </div>

    <div class="mt-6 mb-4 text-center">
      <button @click="addToBlacklist()" class="bg-tertiary hover:bg-primary text-white py-3 px-8 text-sm uppercase rounded shadow">
        <i class="fa fa-home mr-1" /> Blacklist Property
      </button>
    </div>
  </modal>
</template>

<script>
import api from '@/http'
import { mapActions, mapState } from 'vuex'
import debounce from 'lodash/debounce'
export default {
  props: {
    value: Object,
    nameKey: {
      type: String,
      default: null
    },
    nameNumberKey: {
      type: String,
      default: 'address_line1'
    },
    streetKey: {
      type: String,
      default: 'address_line2'
    },
    line3Key: {
      type: String,
      default: 'address_line3'
    },
    townKey: {
      type: String,
      default: 'address_town'
    },
    countyKey: {
      type: String,
      default: 'address_line4'
    },
    postcodeKey: {
      type: String,
      default: 'address_postcode'
    }
  },
  data () {
    return {
      address: this.value,
      suggestions: [],
      selectedSuggestion: null,
      manualOpen: false,
      searching: false
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  watch: {
    address: {
      handler () {
        this.$emit('input', this.address)
        this.search()
      },
      deep: true
    },
    selectedSuggestion (suggestion) {
      if (!suggestion) {
        return
      }

      this.address[this.nameNumberKey] = suggestion.address_name_number
      this.address[this.streetKey] = suggestion.address_line2
      this.address[this.line3Key] = suggestion.address_line3
      this.address[this.townKey] = suggestion.address_town
      this.address[this.countyKey] = suggestion.address_line4
      this.address[this.postcodeKey] = suggestion.address_postcode
    }
  },
  created () {
    this.search()
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    search: debounce(function () {
      if (!RegExp('^[A-PR-UWYZ][A-HJ-Y]?[0-9][0-9A-HJKMNPR-Y]? ?[0-9][ABD-HJLNP-UW-Z]{2}$', 'gi').test(this.address[this.postcodeKey])) {
        return
      }

      this.selectedSuggestion = null
      this.searching = true
      api.get('/address-lookup', {
        params: {
          postcode: this.address[this.postcodeKey]
        }
      }).then((response) => {
        this.suggestions = response.data
        this.searching = false
      }, () => {
        this.searching = false
      })
    }, 500),
    addToBlacklist: debounce(function () {
      api.post('/aps/blacklist-property', {
        office_id: this.selectedOffice.id,
        address: this.address
      }).then(response => {
        this.$emit('saved', response.data)
        this.$emit('leave')
      }).catch(error => {
        if (error.response.status === 422) {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Address validation error',
            info: error.response.data.message
          })
        }
      })
    })
  }
}
</script>
